/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2023 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { toLanguageTag } from '@adobe-commerce/elsie/lib';

export function toDateString(value: string, locale = 'en_US') {
  if (!isDateValid(value)) throw Error('Invalid date string');

  // normalize time to 00:00:00
  const time = value.split(' ')[1];
  if (!time) value = `${value} 00:00:00`;

  return new Date(value).toLocaleDateString(toLanguageTag(locale)).toString();
}

export function isDateValid(dateString: string) {
  const acceptedFormats = [
    /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
    /^\d{1,2}\/\d{1,2}\/\d{4}$/, // MM/DD/YYYY
    /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY
    /^\d{4}\/\d{2}\/\d{2}$/, // YYYY/MM/DD
    /^\d{1,2}\.\d{1,2}\.\d{4}$/, // DD.MM.YYYY
    /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/, // YYYY-MM-DD HH:mm:ss
  ];

  if (!acceptedFormats.some((format) => format.test(dateString))) return false;

  const date = new Date(dateString);
  return !isNaN(date.getTime());
}
